export default "__VITE_ASSET__DwQtGQQ$__"